/*eslint-disable*/
import React, { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationsSideBar from "../../Notifications/NotificationsSideBar";
import { NotificationType } from "../../../types/notifications.t";
import { UserType } from "../../../types/user";
import { useNetwork } from "../../NetworkProvider";
import useMediaQuery from "@mui/material/useMediaQuery";
interface NotificationsModalProps {
    user_id: string;
    locale: string;
    notifications?: NotificationType[]; // Make optional since we get from context
    notificationUsers?: UserType[]; // Make optional for now
    isOpen: boolean;
    setIsNotificationsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NotificationsModal = ({
    user_id,
    locale,
    notifications: propNotifications,
    notificationUsers = [],
    isOpen,
    setIsNotificationsModalOpen,
}: NotificationsModalProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 600px)");
    // Get notifications from NetworkProvider context
    const { notifications: contextNotifications } = useNetwork();

    // Use prop notifications if provided, otherwise use context notifications
    const notifications = propNotifications || contextNotifications || [];

    useEffect(() => {
        if (isOpen && isMobile) {
            const params = new URLSearchParams(location.search);
            params.set("notifications", "true");
            navigate(`${location.pathname}?${params.toString()}`, {
                replace: true,
            });
        }
    }, [isOpen, location.pathname, location.search, navigate]);

    const handleClose = () => {
        if (isMobile) {
            const params = new URLSearchParams(location.search);
            params.delete("notifications");
            navigate(`${location.pathname}?${params.toString()}`, {
                replace: true,
            });
            setIsNotificationsModalOpen(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed top-0 left-0 w-screen h-screen bg-white flex flex-col justify-center items-center"
            style={{ zIndex: 2000 }}
        >
            <button
                className="absolute top-4 left-4 rounded-full hover:bg-gray-200 focus:outline-none"
                onClick={handleClose}
                aria-label="Close notifications modal"
            >
                <FiArrowLeft size={24} />
            </button>
            <div className="w-full mt-10 overflow-y-auto pb-10 h-full">
                <NotificationsSideBar
                    user_id={user_id}
                    onClose={handleClose}
                    locale={locale}
                    notifications={notifications}
                    notificationUsers={notificationUsers}
                />
            </div>
        </div>
    );
};

export default NotificationsModal;
